import { render, staticRenderFns } from "./details_item.vue?vue&type=template&id=87989f54&scoped=true&"
import script from "./details_item.vue?vue&type=script&lang=js&"
export * from "./details_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87989f54",
  null
  
)

export default component.exports